import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { MOCKUP_IMAGE } from '../data/links';
const SHOW_MS = 5000;
const GAP_MS = 9000;
const FIRST_DELAY_MS = 6000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const cycle = (delay: number) => {
      nextTimer = window.setTimeout(() => {
        setMinutes(Math.floor(Math.random() * 12) + 1);
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % recentBuyers.length);
          cycle(GAP_MS);
        }, SHOW_MS);
      }, delay);
    };
    cycle(FIRST_DELAY_MS);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-28 z-40 md:inset-x-auto md:bottom-28 md:left-6 md:w-[360px]" data-id="element-39" data-mp="1fw26s75jurk5">
      <AnimatePresence data-id="element-40" data-mp="1ax7p58jbj91m">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-xl" role="status" data-id="element-41" data-mp="n6lgpg5ejmr3">
            <img src={MOCKUP_IMAGE} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-canvas object-contain p-1" data-id="element-42" data-mp="28maqi3fqhk0u" />
            <div className="min-w-0" data-id="element-43" data-mp="2aol66hya2k5d">
              <p className="text-sm font-bold leading-snug text-navy" data-id="element-44" data-mp="2anjkzknjsh9x">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-xs leading-snug text-navy/70" data-id="element-45" data-mp="2fpqzohzribfy">just purchased the Postoperative Wound Blueprint™</p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-cta-dark" data-id="element-46" data-mp="2pltzvib20009">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-47" data-mp="1ry3iirsayeqv" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-navy/40 transition-colors duration-150 hover:text-navy" aria-label="Close notification" data-id="element-48" data-mp="1wxg3f6zm5bqt">
              <XIcon className="h-4 w-4" data-id="element-49" data-mp="196spa3z3tpvt" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}